import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ["hiddenOnCollapse"]

  connect() {
    this.expand = this.expand.bind(this);
    this.collapse = this.collapse.bind(this);
    App.Helpers.listenToCustomEvent(document, "control:expand",   this.expand)
    App.Helpers.listenToCustomEvent(document, "control:collapse", this.collapse)
  }

  expand(event) {
    const { containerID } = event.detail;
    if (containerID == this.containerID) {
      this.hiddenOnCollapseTargets.forEach(target => target.classList.remove("hide-activity"));
      document.dispatchEvent(createCustomEvent("sortable-list:expand", this.element, { containerID }));
    }
  }

  collapse(event) {
    const { containerID } = event.detail;
    if (containerID == this.containerID) {
      this.hiddenOnCollapseTargets.forEach(target => target.classList.add("hide-activity"));
      document.dispatchEvent(createCustomEvent("sortable-list:collapse", this.element, { containerID }));
    }
  }

  get containerID() {
    return this.data.get("container-id");
  }
}



// WEBPACK FOOTER //
// ./app/components/card_lists/assets/javascript/card-lists-expandable-card-list-header-controller.js